import React from 'react';
import Card from '../../Common/Card';
import DetailsRow from './DetailsRow';
import AccountService from '../../../Service/AccountService';

const displayItem = {
    name: 'Bank Name',
    type: 'Account Type',
    mask: 'Last 4 digit of Your Account'
};

export default class Plaid extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _plaidInfo: null,
            _message: 'Loading...'
        };
    }

    getPlaidDetails = async () => {
        const _plaidInfo = await AccountService.getPlaidDetails(this.props.match.params.id);
        if (!_plaidInfo.mask) {
            this.setState({
                // _message: _plaidInfo.data
                _message:_plaidInfo
            });
        } else {
            this.setState({ _plaidInfo });
        }
    }

    componentDidMount() {
        this.getPlaidDetails();
    }

    render() {
        if (!this.state._plaidInfo) {
            return this.state._message;
        }
        return (
            <Card >
                {
                    Object.keys(displayItem).map((key) => (
                        <DetailsRow
                            key={`${this.state._plaidInfo.account_id}${key}`}
                            lable={displayItem[key]}
                            value={this.state._plaidInfo[key]}
                        />
                    ))
                }
                {
                    <>

                        <DetailsRow
                            lable='Available balance'
                            value={`₱${this.state._plaidInfo.balances.available}`}
                        />
                        <DetailsRow
                            lable='Current balance'
                            value={`₱${this.state._plaidInfo.balances.current}`}
                        />
                    </>
                }

            </Card>
        );

    }
}
